import { FaDocker, FaNodeJs, FaPython } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import { VscJson } from "react-icons/vsc";

const CodeTreeLoader = ({ files={}, cardCount = 4 }) => {
  const fileKeys = files && typeof files === "object"
    ? Object.keys(files)
    : [];

  const itemCount = fileKeys.length > 0 ? fileKeys.length : cardCount;

  return (
    <div className="item_loader_body_code">
      {Array.from({ length: itemCount }).map((_, index) => (
        fileKeys[index] ? (
          <div className="item_loader_code_tree_p">
            {fileKeys[index].endsWith(".py") && <FaPython />}
            {fileKeys[index].endsWith(".js") && <FaNodeJs />}
            {fileKeys[index].endsWith(".json") && <VscJson />}
            {fileKeys[index].endsWith(".txt") && <FiFileText />}
            {fileKeys[index].startsWith("Dockerfile") && <FaDocker />}
            {!fileKeys[index].match(/\.(py|js|json|txt)$/) && fileKeys[index] !== "Dockerfile" && <FiFileText />}
            
            <span >{fileKeys[index]}</span>
          </div>

        ) : (
          <div className="item_loader_code_tree"></div>
        )
      ))}
    </div>
  );
};

export default CodeTreeLoader;